import { useEffect, useMemo, useRef, useState } from "react";
import Timeline from "./components/Timeline";
import TrackPlayPoint from "./components/TrackPlayPoint";
import trackStateStore from "@/stores/clipEditor/trackState";
import playerStore from "@/stores/clipEditor/player";
import { getGridPixel } from "@/utils/canvasUtil";
import "./index.less";
import { parseUrl } from "@/utils/file";
import { VideoTrack } from "@/stores/clipEditor/class/VideoTrack";
import ZoomControl from "./components/TrackControl";
import { observer } from "mobx-react";
import TrackLine from "./components/TrackLine";
import { debounce } from "@/utils";
import CanvasPlayer from "./components/Player/CanvasPlayer";
import { v4 as uuid } from "uuid";
import { useSearchParams } from "react-router-dom";
import useDragTrack from "./hooks/useDragTrack";

export interface EditorConfig {
  background?: string;
  timeline?: {
    background?: string;
    textColor?: string;
    textSize?: number;
    lineWidth?: number;
    longLineColor?: string;
    shortLineColor?: string;
  };
  pointer?: {
    lineColor?: string;
    pointerColor?: string;
  };
}

export interface ClipEditorProps {
  config?: EditorConfig;
}

const ClipEditor = function (props: ClipEditorProps) {
  const { config = {} } = props;
  const [searchParams] = useSearchParams();
  const { onMouseDown, onMouseMove, onMouseUp } = useDragTrack();
  const [lastScrollTop, setLastScrollTop] = useState(0);

  const trackListContainer = useRef(null);
  const trackList = useRef(null);
  const [dropLineIndex, setDropLineIndex] = useState(-1);
  const [insertBefore, setInsertBefore] = useState(true);
  const offsetLine = {
    left: 10, // 容器 margin, 为了显示拖拽手柄
    right: 200,
  };
  const [startX, setStartX] = useState(0 - offsetLine.left);

  const trackStyle = useMemo(() => {
    return {
      flexShrink: 0,
      width:
        getGridPixel(
          trackStateStore.trackScale,
          trackStateStore.getFrameCount()
        ) + offsetLine.right,
    };
  }, [trackStateStore.trackScale, trackStateStore.getFrameCount()]);

  // async function onUpload() {
  //   try {

  //     const { id, file, clip } = await parseUrl(data?.play_info?.play_url);
  //     const videoTrack = new VideoTrack(
  //       {
  //         id,
  //         url: URL.createObjectURL(file),
  //         name: data.name,
  //         format: file.type,
  //         width: clip.meta.width,
  //         height: clip.meta.height,
  //         duration: Math.round(clip.meta.duration / 1000 / 1000),
  //       },
  //       playerStore.playStartFrame
  //     );
  //     videoTrack.resize({
  //       width: playerStore.playerConfig.playerWidth,
  //       height: playerStore.playerConfig.playerHeight,
  //     });
  //     trackStateStore.addTrack(videoTrack);
  //   } catch (error) {
  //     console.error("Error parsing URL:", error);
  //   }
  // }

  let maxDelta = 0;

  const setScale = debounce(() => {
    trackStateStore.trackScale -= maxDelta > 0 ? 10 : -10;
    maxDelta = 0;
  }, 100);

  const handleWheel = (event: any) => {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
      if (maxDelta === 0) {
        maxDelta = event.deltaY;
      }
      setScale();
    }
  };
  function handleScroll() {
    // document.getElementById("track-menu").style.overflowY = "auto";
    const { scrollLeft, scrollTop } = trackList.current;
    setStartX(scrollLeft - offsetLine.left);
  }

  function setSelectTract(event: any, line: number, index: number) {
    event.preventDefault();
    event.stopPropagation();
    trackStateStore.setSelectTrackItem({
      line,
      index,
    });
  }

  function handleSelectFrame(frame: number) {
    const playFrame = frame - 1;
    const startFrane =
      playFrame < 0
        ? 0
        : playFrame > trackStateStore.getFrameCount()
          ? trackStateStore.getFrameCount()
          : playFrame;
    playerStore.isPause = true;
    playerStore.playStartFrame = startFrane;
  }

  useEffect(() => {
    // trackStateStore.setIsClip(isClip);
    // 模拟加载视频素材
    // onUpload();

    if (config) {
      trackStateStore.setEditorConfig(config);
    }
  }, [config]);

  return (
    // <div
    //   style={{
    //     display: "flex",
    //     height: "100vh",
    //     flexDirection: "column",
    //     background: "rgb(32 32 35)",
    //     padding: 20,
    //     color: "#fff",
    //     boxSizing: "border-box",
    //   }}
    // >
    //   <div style={{ flex: 1 }}>

    //     <Button
    //       style={{ position: "absolute", right: 40, top: 60 }}
    //       onClick={onUpload}
    //     >
    //       添加视频
    //     </Button>

    //     <Button
    //       style={{ position: "absolute", right: 40, top: 60 }}
    //       onClick={() => {
    //         console.log(trackStateStore.trackList);
    //       }}
    //     >
    //       保存
    //     </Button>
    //   </div>

    <div
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        // background: "rgb(32 32 35)",
        color: "#fff",
        boxSizing: "border-box",
      }}
    >
      <CanvasPlayer />
      <ZoomControl
        value={trackStateStore.trackScale}
        onChange={(v) => {
          trackStateStore.setTrackScale(v);
        }}
      />
      <div
        style={{
          display: "flex",
          overflow: "hidden",
        }}
      >
        <div
          ref={trackList}
          className="track-list"
          style={{
            position: "relative",
            width: "100%",
            overflowX: "auto",
            overflowY: "auto",
            height: "160px",
            background: trackStateStore.editorConfig?.background,
          }}
          onScroll={handleScroll}
          onWheel={handleWheel}
          onClick={(e) => setSelectTract(e, -1, -1)}
        >
          <Timeline
            start={startX}
            scale={trackStateStore.trackScale}
            style={{ height: "30px", borderTop: "1px solid #D8D8D8" }}
            onSelectFrame={handleSelectFrame}
          />

          <div
            style={{
              display: "flex",
              padding: "30px 0 0",
              position: "absolute",
              minWidth: "100%",
              minHeight: "calc(100% - 30px)",
            }}
            ref={trackListContainer}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseUp}
          >
            <div id="track-container" style={trackStyle}>
              {trackStateStore.showTrackList.map((lineData, lineIndex) => (
                <TrackLine
                  key={lineData.list.reduce((r, item) => r + item.id, "line")}
                  style={{
                    marginLeft: `${offsetLine.left}px`,
                  }}
                  className={`${dropLineIndex === lineIndex ? (insertBefore ? "showLine-t" : "showLine-b") : ""}`}
                  lineType={lineData.type}
                  lineIndex={lineIndex}
                  isMain={lineData.main}
                  lineData={lineData.list}
                />
              ))}
            </div>
            <TrackPlayPoint />

            {/* 辅助线 */}
            {!!trackStateStore.showTrackList.length &&
              trackStateStore.dragData.fixLines
                .reduce((r, item) => r.concat(item), [])
                .map((line, i) => (
                  <div
                    key={i}
                    className="absolute bottom-0 z-30 w-px bg-yellow-300 pointer-events-none -top-5 dark:bg-yellow-300"
                    style={{
                      position: "absolute",
                      width: "1px",
                      top: "-4px",
                      bottom: 0,
                      zIndex: 30,
                      pointerEvents: "none",
                      left: `${line.position + 10}px`,
                      background: "yellow",
                    }}
                  ></div>
                ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(ClipEditor);
